import TransMsgPage from '../../views/TransMsgPage';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';
import { actions as assessmentactions } from '../../../state/assessment';
const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  project: state.shift.project[ownProps.match.params.projectId],
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  reponame: state.shift.assessment.reponame,
  description: state.shift.assessment.description,
  reference_id: state.shift.assessment.reference_id,
  name: state.shift.auth.name,
  username: state.shift.auth.username,
  projectList: state.shift.assessment.RepositoryNameList,
  clientname: state.shift.assessment.clientname,
  opportunity_num: state.shift.assessment.opportunity_num,
  reponame: state.shift.assessment.reponame,
  srclang: state.shift.assessment.srclang,
  tgtlang: state.shift.assessment.tgtlang,
  financialforce_id:state.shift.assessment.financialforce_id
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickOKHandler: value => {
      dispatch(push(`/${locale}/shift`));
      dispatch(assessmentactions.resetAssessmentStore());
    },

    // translation: reponame => {
    //   dispatch(actions.translation(reponame));
    // }

    translation: (
      reponame,
      srclang,
      tgtlang,
      description,
      financialforce_id,//opportunity_num,
      clientname,
      username,
      name
    ) => {

      dispatch(
        actions.translation(
          reponame,
          srclang,
          tgtlang,
          description,
          financialforce_id,//opportunity_num,
          clientname,
          username,
          name
        )
      );         //.then(() => dispatch(push(`/${locale}/resultmsgpage`)))

     },



  };
};

const TransMsgPageComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(TransMsgPage);

export default TransMsgPageComponent;



// WEBPACK FOOTER //
// ./src/components/container/TransMsgPage/index.js